module.exports = __webpack_public_path__ + "img/mapper-page.5b4d9718.png";